import { Button, Card, Progress, Space, Tag } from 'antd';
import type { BulkItem, BulkItemPhase } from '@/hooks/useBulkExtraction';

const PHASE_COLOR: Record<BulkItemPhase, string> = {
  queued: 'default',
  uploading: 'processing',
  extracting: 'processing',
  ready: 'success',
  saved: 'success',
  skipped: 'default',
  failed: 'error',
};

const PHASE_LABEL: Record<BulkItemPhase, string> = {
  queued: 'Queued',
  uploading: 'Uploading…',
  extracting: 'Extracting…',
  ready: 'Ready for review',
  saved: 'Saved',
  skipped: 'Skipped',
  failed: 'Failed',
};

interface Props {
  item: BulkItem;
  onReview: () => void;
  onSkip: () => void;
}

export function BulkQueueItem({ item, onReview, onSkip }: Props) {
  const inFlight = item.phase === 'uploading' || item.phase === 'extracting';
  const done = item.phase === 'saved' || item.phase === 'skipped';

  return (
    <Card size="small" style={{ marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space direction="vertical" size={0} style={{ flex: 1, minWidth: 0 }}>
          <strong style={{ wordBreak: 'break-all' }}>{item.file.name}</strong>
          <Tag color={PHASE_COLOR[item.phase]}>{PHASE_LABEL[item.phase]}</Tag>
          {item.errorMessage && <small style={{ color: '#cf1322' }}>{item.errorMessage}</small>}
        </Space>
        <Space style={{ marginLeft: 16 }}>
          {inFlight && (
            <Progress
              percent={item.phase === 'uploading' ? 35 : 70}
              status="active"
              showInfo={false}
              style={{ width: 100 }}
            />
          )}
          {item.phase === 'ready' && (
            <Button type="primary" size="small" onClick={onReview}>
              Review
            </Button>
          )}
          {!done && (
            <Button size="small" onClick={onSkip}>
              Skip
            </Button>
          )}
        </Space>
      </div>
    </Card>
  );
}
